export default __webpack_public_path__ + "static/media/android.62aabe7e.png";